/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Stake_Or_Hashrate_NameInputs */



/**
* | output |
* | --- |
* | "Stake/Hashrate" |
*
* @param {Metric_Stake_Or_Hashrate_NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_stake_or_hashrate_name = /** @type {((inputs?: Metric_Stake_Or_Hashrate_NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Stake_Or_Hashrate_NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Stake/Hashrate")
});